import { useMemo } from "react";
import useSWR from "swr";

import { apiUsersEndpoints } from "@api/Endpoints";

import { fetcher } from "@utils/swrUtils";

import { AppRolesResponse } from "../models/app-roles-models";

export function useGetAppRoles() {
  const url = apiUsersEndpoints.appRolesList();

  const { data, error, isLoading } = useSWR<AppRolesResponse, Error>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(
    () => ({ appRoles: data?.appRoles, isLoading, error }),
    [data, isLoading, error]
  );
}
